<template>
    <div class="chat__message-bubble">
        <p v-html="message.text"></p>
    </div>
</template>

<script>

export default {
    props: {
        message: {
            type: Object,
            required: true
        }
    },

    data() {
        return {

        }
    },

    mounted() {

    },

    computed: {

    },

    methods: {

    }

}
</script>

<style scoped>

</style>
